export const actionTypes = {
  ADD_COMPANY_SUCCESS: "ADD_COMPANY_SUCCESS",
  LOADING: "LOADING",
  SET_COMPANIES: "SET_COMPANIES",
  SET_SELECTED_COMPANY: "SET_SELECTED_COMPANY",
  CLEAR_SELECTED_COMPANY: "CLEAR_SELECTED_COMPANY",
  CLEAR_COMPANY_ERRORS: "CLEAR_COMPANY_ERRORS"
};
